//defining an array for the section colors
export const COLORS = ['ocean', 'teal', 'fire', 'turquoise', 'ocean', 'sun', 'green', 'night'];
